<template lang="">
	<sf-modal-layout :title="getMessage_('SWCC000547')" :show="TableDataManagementModal" :closeModal="closeModal" size="s">
		<el-row>
			<!-- 스키마 -->
			<sf-select-group
				:label="getMessage_('SWCC000788')"
				labelPosition="left"
				:labelSpan="12"
				:inputValue="tableDataManagementModalValue.schema"
				:onChange="value => chgSchema(value)"
				:options="allSchemas"
				:disabled="tableDataManagementModalValue.flg == 'U'"
			/>
		</el-row>
		<el-row>
			<!-- 테이블 -->
			<sf-select-group
				:label="getMessage_('SWCC000538')"
				labelPosition="left"
				:labelSpan="12"
				:inputValue="tableDataManagementModalValue.tableId"
				:onChange="value => setModalValue_({ key: `tableId`, value })"
				:options="unmanagedTables"
				:disabled="tableDataManagementModalValue.flg == 'U'"
			/>
		</el-row>
		<el-row>
			<!-- 저장기한 -->
			<sf-input-group
				:label="getMessage_('SWCC000541')"
				labelPosition="left"
				:labelSpan="12"
				:inputValue="tableDataManagementModalValue.saveDays"
				:onChange="value => onChange('saveDays', value, 'number')"
				:elProps="{ maxlength: 10 }"
			/>
		</el-row>
		<el-row>
			<!-- 삭제주기(일) -->
			<sf-input-group
				:label="getMessage_('SWCC000542')"
				labelPosition="left"
				:labelSpan="12"
				:inputValue="tableDataManagementModalValue.delCycleDay"
				:onChange="value => onChange('delCycleDay', value, 'number')"
				:elProps="{ maxlength: 10 }"
			/>
		</el-row>
		<el-row>
			<!-- 삭제주기(시간) -->
			<sf-input-group
				:label="getMessage_('SWCC000317')"
				labelPosition="left"
				:labelSpan="12"
				:inputValue="tableDataManagementModalValue.delCycleTime"
				:onChange="value => chgDelCycleTime(value)"
				:elProps="{ maxlength: 10 }"
			/>
		</el-row>
		<template v-slot:footer>
			<sf-button v-if="isButton_(scrId, 'CD') && tableDataManagementModalValue.flg == 'U'" line color="error" :onClick="deleteAction">{{
				getMessage_('SWCC000107')
			}}</sf-button>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000113') }}</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU') && tableDataManagementModalValue.flg == 'U'" :onClick="saveAction">{{
				getMessage_('SWCC000279')
			}}</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD') && tableDataManagementModalValue.flg == 'I'" :onClick="addAction">{{
				getMessage_('SWCC000007')
			}}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TableDataManagement/store/helpers';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.getAllSchemas_({ plantCd: this.user.plantCd }).catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});

		this.getUnmanagedTables_({ plantCd: this.user.plantCd, schema: '' })
			.then(() => {
				this.tableDataManagementModalValue.tableId = this.unmanagedTables[0].value;
			})
			.catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		schema() {
			return yup.object().shape({
				tableId: yup.string().required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000538')])), //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
				saveDays: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000541')]))
					.integer(this.$sf_formatString(this.getMessage_('SWCC000965'), [this.getMessage_('SWCC000541')]))
					.moreThan(-1, this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('SWCC000541')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000541')])), //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
				delCycleDay: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000542')]))
					.integer(this.$sf_formatString(this.getMessage_('SWCC000965'), [this.getMessage_('SWCC000542')]))
					.moreThan(-1, this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('SWCC000542')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000542')])), //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
				delCycleTime: yup
					.string()
					.max(5, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000317'), 5]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000317')])) //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		addAction() {
			try {
				// 유효성 검사
				this.schema.validateSync(this.tableDataManagementModalValue);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('SWCC000503'), //추가하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000007'), clickFn: () => this.add() }] //추가
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		add() {
			this.$sf_toggleLoading(true);
			this.addTables_({
				params: { ...this.tableDataManagementModalValue }
			})
				.then(response => {
					this.$sf_toast({ type: 'ok', message: response.message });
					this.getTableDataManagementList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
					this.closeModal();
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		saveAction() {
			try {
				// 유효성 검사
				this.schema.validateSync(this.tableDataManagementModalValue);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('SWCC000553'), //수정하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000279'), clickFn: () => this.save() }] //수정
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		save() {
			this.$sf_toggleLoading(true);
			this.saveTables_({ params: { ...this.tableDataManagementModalValue } })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: response.message });
					this.getTableDataManagementList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
					this.closeModal();
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		deleteAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000554'), //삭제하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: () => this.delete() }] //삭제
			});
		},

		delete() {
			this.$sf_toggleLoading(true);
			this.delTables_({ params: { ...this.tableDataManagementModalValue } })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: response.message });
					this.getTableDataManagementList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
					this.closeModal();
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		onChange(key, value, type) {
			if (type == 'number') {
				this.setModalValue_({ key: key, value: this.returnNum(value) });
			} else {
				this.setModalValue_({ key: key, value: value });
			}
		},

		returnNum(str) {
			return str.replace(/[^0-9]/g, '');
		},

		chgDelCycleTime(val) {
			let result = val;
			if (val.length <= 5) {
				if (val.length >= 4 && val.indexOf(':') == -1) {
					result = val.substr(0, 2) + ':' + val.substr(2, 4);
				}
				this.setModalValue_({ key: `delCycleTime`, value: result });
			}
		},

		chgSchema(value) {
			this.setModalValue_({ key: `schema`, value });
			this.getUnmanagedTables_({ plantCd: this.user.plantCd, schema: this.tableDataManagementModalValue.schema })
				.then(() => {
					this.tableDataManagementModalValue.tableId = this.unmanagedTables[0].value;
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				});
		},

		closeModal() {
			this.closeModal_();
		}
	}
};
</script>
<style lang=""></style>
